import { render, staticRenderFns } from "./internal-document.vue?vue&type=template&id=4e7cf60e&scoped=true&"
import script from "./internal-document.vue?vue&type=script&lang=js&"
export * from "./internal-document.vue?vue&type=script&lang=js&"
import style0 from "./internal-document.vue?vue&type=style&index=0&id=4e7cf60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7cf60e",
  null
  
)

export default component.exports